import { CogIcon } from "@heroicons/react/solid";
import React from "react";
export function BlockCookiePreferences(props) {
    var handleClick = function() {
        // @ts-ignore
        if (window !== undefined && window.Optanon !== undefined) {
            // @ts-ignore
            Optanon.ToggleInfoDisplay();
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-content my-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content-wrapper"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: handleClick,
        className: "bg-purple text-white pl-2 pr-4 py-1 flex whitespace-nowrap items-center gap-2 mx-auto"
    }, /*#__PURE__*/ React.createElement(CogIcon, {
        className: "w-6 h-6"
    }), props.label || "Cookie Preferences")));
}
